import { useFormik } from "formik";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { updateUserConsentAgreedSucess } from "../../actions/authorization/userInfo";
import { dispatchSignOut } from "../../actions/common/session";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useFlashMessage } from "../../hooks/useFlashMessage";
import AppStateInterface from "../../interfaces/AppStateInterface";
import AuthorizationStateInterface from "../../interfaces/AuthorizationStateInterface";
import { useMutateConsentAgreement } from "./useMutateConsentAgreement";

const initialValues = {
  consentAgreement: false,
};

const validationSchema = yup.object().shape({
  consentAgreement: yup
    .bool()
    .oneOf([true], "利用規約・プライバシーポリシーに同意してください"),
});

export const useConsentAgreement = () => {
  const currentOperator = useSelector<
    AppStateInterface,
    AuthorizationStateInterface["currentOperator"]
  >((state) => state.session.currentOperator);

  // ローディング中にモーダルが出ないように、currentOperatorが取得できてない時はfalseにする
  const isConsentAgreed = currentOperator
    ? currentOperator.isConsentAgreed
    : false;

  const dispatch = useAppDispatch();

  const { showErrorMessage } = useFlashMessage();

  const signOut = () => {
    dispatch(dispatchSignOut());
  };

  const { mutate, isPending } = useMutateConsentAgreement({
    onSuccess: () => {
      dispatch(updateUserConsentAgreedSucess());
    },
    onError: () => {
      showErrorMessage("データの更新に失敗しました");
    },
  });
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: () => {
      mutate();
    },
  });

  const checkboxProps = {
    onChange: () => {
      const { consentAgreement } = formik.values;
      formik.setFieldValue("consentAgreement", !consentAgreement);
    },
    name: "consentAgreement",
    value: "consentAgreement",
    ...(formik.values.consentAgreement ? { checked: true } : {}),
  };
  return {
    checkboxProps,
    handleSubmit: formik.handleSubmit,
    errors: formik.errors.consentAgreement,
    isPending,
    isOpen: !isConsentAgreed,
    signOut,
  };
};
